/**
 * User preference API — current-user keyed preference reads and bulk writes.
 *
 * Wraps /api/odl-app/user-preferences/ for durable per-user UI state such as
 * dashboard view options, grid columns, and app customization.
 */
import apiClient from '@sophocles/http-common';

const API_PATH = '/odl-app/user-preferences/';

export const fetchUserPreferences = ({ key, keyPrefix } = {}) => {
  const params = {};
  if (key) params.key = key;
  if (keyPrefix) params.key_prefix = keyPrefix;
  return apiClient.get(API_PATH, { params }).then(res => res.data);
};

export const bulkUpsertUserPreferences = items => apiClient.put(`${API_PATH}bulk/`, items).then(res => res.data);
